<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [baseZIndex]="10000"></p-confirmDialog>
@if (formLoading) {
<div class="progress-spinner">
  <app-spinner [formLoading]="formLoading"></app-spinner>
</div>
}
<div class="topinfo d-flex align-items-center">
  <div class="col-lg-4 text-right toprighttext position-relative">
    <div class="d-flex justify-content-start gap-3 align-items-center topinfotr">
      <div class="d-flex gap-2">
        <span class="p-input-icon-right"><a href="/tapechart" target="_blank">
            <h1>T</h1>
          </a></span>
        <span class="p-input-icon-right"><a href="/reservations" target="_blank">
            <h1>R</h1>
          </a></span>
      </div>
      <span class="p-input-icon-right mr-5 mt-2">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (change)="redirectToReservations()" [(ngModel)]="searchName"
          placeholder="Search" />
      </span>
    </div>
  </div>
  <div class="col-lg-5 text-center">
    <span style="font-size: 16px;">
    </span>
  </div>
  <div class="col-lg-3 text-right pr-5">
    <h2 class="m-0" style="font-size: 26px;"> {{formTitle}} #{{order?.orderId}}</h2>
    @if (isPopup) {
    <button mat-icon-button (click)="closePopUp()" class="close-btn" [mat-dialog-close]="true"
      style="float:right;background-color: transparent;">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
    }
  </div>
</div>
<div class="d-flex justify-content-end align-items-center mb-2">
  @if (!isUrlCopied) {
  <button pButton type="button" label="Copy URL" icon="pi pi-copy" (click)="copyUrlToClipboard(order?.orderId)"
    class="p-button-sm"></button>
  }
  @if (isUrlCopied) {
  <span class="text-success fw-bold d-flex align-items-center">
    <i class="pi pi-check"></i>
    &nbsp;Url Copied
  </span>
  }
</div>
<mat-tab-group class="tabs-group edit-order-grp">
  <mat-tab label="Order">
    <div>


      <div
        class="mb-1 d-flex flex-wrap gap-2 align-items-center justify-content-between p-2 edit-order sticky-edit-order"
        style="background-color: #F0F2FF;">
        <div class="leftbtn">
          <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0">
            <button type="button" class="btn btn-primary" [disabled]="formLoading" (click)="updateReservations()">Update</button>
            <button type="button" class="btn btn-light ml-2" [disabled]="formLoading" [mat-dialog-close]="true"
              (click)="gotoReservation()">Cancel</button>
          </div>
        </div>
        <div class="rightselectbx d-flex gap-2 align-items-center flex-wrap">
          <button type="button" class="btn btn-primary ml-2" [disabled]="formLoading" (click)="openCreateReservationPopUp()">Add
            Reservation</button>
          <span class="p-float-label">
            <select name="newurl2" [disabled]="formLoading" (change)="onChangeSetEmailType($event.target.value)" class="form-select">
              <option value="">Select...</option>
              <option value="contract">Email Contract</option>
              <option value="invoice">Email Invoice</option>
              <option value="checkInDetails">Email Check-In Details</option>
              <option value="rentalCar">Email Rental Car Confirmation</option>
            </select>
          </span>
          <button type="button" class="btn btn-primary ml-2" [disabled]="formLoading" (click)="sendReservationEmail()">Send Email
          </button>
          <!-- <span class="p-float-label">
            <p-dropdown [options]="lostFounds" formControlName="lostFoundId" optionLabel="itemName"
              optionValue="lostFoundId" [filter]="true" filterBy="itemName" [showClear]="false"
              placeholder="Select lost item name">
            </p-dropdown>
            <label for="Select lost item name">Select..</label>
          </span> -->
        </div>
      </div>
      <div class="edit-order padding-remove">

        <div [formGroup]="form1">
          <!-- <div class="mb-1 d-flex align-items-center justify-content-between p-2" style="background-color: #F0F2FF;">
          <div class="leftbtn">
            <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0">
              <button type="button" class="btn btn-primary">Update</button>
              <button type="button" class="btn btn-light ml-2" [mat-dialog-close]="true"
              (click)="gotoReservation()">Cancel</button>
            </div>
          </div>
          <div class="rightselectbx">
            <span class="p-float-label">
              <p-dropdown [options]="lostFounds" formControlName="lostFoundId" optionLabel="itemName"
                optionValue="lostFoundId" [filter]="true" filterBy="itemName" [showClear]="false"
                placeholder="Select lost item name">
              </p-dropdown>
              <label for="Select lost item name">Select lost item name</label>
            </span>
          </div>
        </div> -->

          <div class="row m-0">
            <div class="col-lg-12 createdlist">
              <ul class="list-group list-group-horizontal w-100 mb-1">
                <li class="list-group-item p1">
                  <small class="fw-bold d-block text-black">
                    Created:
                  </small>
                  <span
                    pTooltip="{{order?.createDate|date:'MM-dd-yyyy hh:mm a'}}">{{order?.createDate|date:'MM-dd-yyyy'}}</span>
                </li>
                <li class="list-group-item p2">
                  <small class="fw-bold d-block text-black">
                    Quote:
                  </small>
                  <span
                    pTooltip="{{order?.quoteDate|date:'MM-dd-yyyy hh:mm a'}}">{{order?.quoteDate|date:'MM-dd-yyyy'}}</span>
                </li>
                <li class="list-group-item p3">
                  <small class="fw-bold d-block text-black">
                    Sold:
                  </small>
                  <span
                    pTooltip="{{order?.saleDate|date:'MM-dd-yyyy hh:mm a'}}">{{order?.saleDate|date:'MM-dd-yyyy'}}</span>
                </li>
                <li class="list-group-item p6">
                  <small class="fw-bold d-block text-black">
                    Order Id / Code:
                  </small>
                  <span>{{order?.orderId}} / {{order?.orderIdMask}} </span>
                </li>
                <li class="list-group-item p4">
                  <small class="fw-bold d-block text-black">
                    Close:
                  </small>
                  <span
                    pTooltip="{{order?.closeDate|date:'MM-dd-yyyy hh:mm a'}}">{{order?.closeDate|date:'MM-dd-yyyy'}}</span>
                </li>

              </ul>
            </div>
            <div class="col-lg-12 soldby">
              <ul class="list-group list-group-horizontal">
                <li class="list-group-item">
                  <small class="fw-bold d-block text-black">
                    Sold by
                  </small>
                  <div class="d-flex">
                    <span class="p-float-label w_122">
                      <p-dropdown class="w-100" [options]="salesmen" formControlName="creditSaleTo"
                        (onChange)="updateOrder()" optionLabel="fullName" optionValue="userId" [filter]="true"
                        filterBy="fullName" [showClear]="false" placeholder="Select Name"></p-dropdown>
                      <label for="creditSaleTo">Name</label>
                      @for (validation of validationMessages.creditSaleTo; track validation) {
                      <span>
                        @if (form1.get('creditSaleTo').hasError(validation.type) && (form1.get('creditSaleTo').dirty ||
                        form1.get('creditSaleTo').touched)) {
                        <small class="p-invalid">{{validation.message}}
                        </small>
                        }
                      </span>
                      }
                    </span>
                    <span class="p-float-label w_122">
                      <p-dropdown class="w-100" [options]="salesmen" formControlName="creditSaleTo2"
                        (onChange)="updateOrder()" optionLabel="fullName" optionValue="userId" [filter]="true"
                        filterBy="fullName" [showClear]="false" placeholder="Select Name"></p-dropdown>
                      <label for="creditSaleTo2">Name2</label>
                      @for (validation of validationMessages.creditSaleTo2; track validation) {
                      <span>
                        @if (form1.get('creditSaleTo2').hasError(validation.type) && (form1.get('creditSaleTo2').dirty
                        || form1.get('creditSaleTo2').touched)) {
                        <small class="p-invalid">{{validation.message}}
                        </small>
                        }
                      </span>
                      }
                    </span>
                  </div>
                </li>
                <!-- <li class="list-group-item">
              <small class="fw-bold d-block text-black">
                Sales Tax
              </small>
              <span class="p-float-label w_122">
                <input type="text" class="form-control" formControlName="salesTax" id="salesTax" placeholder="salesTax"
                  name="text">
                  <span *ngFor="let validation of validationMessages.salesTax">
                    <small class="p-invalid"
                      *ngIf="form1.get('salesTax').hasError(validation.type) && (form1.get('salesTax').dirty || form1.get('salesTax').touched)">{{validation.message}}
                    </small>
                  </span>
                </span>
              </li>
              <li class="list-group-item">
                <small class="fw-bold d-block text-black">
                  Room Tax
                </small>
                <span class="p-float-label w_122">
                  <input type="text" class="form-control" formControlName="tax" id="tax" placeholder="Room Tax"
                    name="text">
                    <span *ngFor="let validation of validationMessages.tax">
                      <small class="p-invalid"
                        *ngIf="form1.get('tax').hasError(validation.type) && (form1.get('tax').dirty || form1.get('tax').touched)">{{validation.message}}
                      </small>
                    </span>
                  </span>
                </li> -->
                <li class="list-group-item">
                  <small class="fw-bold d-block text-black">
                    Referral Source
                  </small>
                  <!-- <span class="w_122">
                  <p-dropdown class="w-100" [options]="referralSources"
                    [(ngModel)]="reservation.referralSourceId" optionLabel="name"
                  optionValue="value"></p-dropdown>
                </span> -->
                  <span class="p-float-label w_122">
                    <p-dropdown class="w-100" [options]="referralSources" formControlName="referralSourceId"
                      optionLabel="name" optionValue="value" (onChange)="updateOrder()" placeholder=""></p-dropdown>
                    <!-- <label for="Status">Order Status</label> -->
                    @for (validation of validationMessages.referralSourceId; track validation) {
                    <span>
                      @if (form1.get('referralSourceId').hasError(validation.type) &&
                      (form1.get('referralSourceId').dirty || form1.get('referralSourceId').touched)) {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                      }
                    </span>
                    }
                  </span>
                </li>
                <li formGroupName="orderInvoice" class="list-group-item">
                  <small class="fw-bold d-block text-black">
                    Credit Card Premium
                  </small>
                  <span class="p-float-label w_122">
                    <input type="text" class="form-control" (change)="updateOrder()" formControlName="ccPremiumPct"
                      id="ccPremiumPct" placeholder="Credit Card Premium" name="premium">
                    @for (validation of validationMessages.ccPremiumPct; track validation) {
                    <span>
                      @if (form1.get('orderInvoice.ccPremiumPct').hasError(validation.type) &&
                      (form1.get('orderInvoice.ccPremiumPct').dirty || form1.get('orderInvoice.ccPremiumPct').touched))
                      {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                      }
                    </span>
                    }
                  </span>
                </li>
                <li class="list-group-item">
                  <small class="fw-bold d-block text-black">
                    Order Status:
                  </small>
                  <span class="p-float-label w_172">
                    <p-dropdown class="w-100" (onChange)="updateOrder()" [options]="orderStatuses"
                      formControlName="status" optionLabel="name" optionValue="value"
                      placeholder="Order Status"></p-dropdown>
                    @for (validation of validationMessages.status; track validation) {
                    <span>
                      @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty ||
                      form1.get('status').touched)) {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                      }
                    </span>
                    }
                  </span>
                </li>
                <li class="list-group-item p5">
                  <small class="fw-bold d-block text-black">
                    Cancel:
                  </small>
                  <span class="w_auto"
                    pTooltip="{{reservation?.cancelDate|date:'MM-dd-yyyy hh:mm a'}}">{{reservation?.cancelDate|date:'MM-dd-yyyy'}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>





      @for (reservation of order?.reservations; track reservation; let i = $index) {
      <div>
        <app-reservation [order]="order" [paymentSources]="paymentSources" (refreshOrder)="doRefreshOrder()"
          [reservation]="reservation" (getReservations)="getReservationlist($event)"
          [reservationCount]="order?.reservations.length" [reservationIndex]="i + 1"></app-reservation>
      </div>
      }



      <div class="row mx-0 my-3 justify-content-between tabletile" style="background-color: maroon;">
        <div class="col-sm-6">
          <h2 class="text-white m-0 py-1 fw-bold">Invoice</h2>
        </div>
      </div>

      <div class="row mx-0y-5 gy-lg-0 m-0">
        <div class="col-lg-12 invoicetable p-0">
          <div class="row m-0">
            <div class="col-lg-11 pr-5 pl-0">
              <div class="table-responsive-xl">
                <table class="table table-bordered mb-3">
                  <thead align="center">
                    <tr>
                      <th style="width: 120px">
                        Property
                      </th>
                      <th style="width: 130px">
                        Added
                      </th>
                      <th style="width: 500px">
                        Description
                      </th>
                      <th>
                        #
                      </th>
                      <th class="text-right">
                        Price
                      </th>
                      <th class="text-right">
                        $ Disc
                      </th>
                      <th class="text-right">
                        SubTotal
                      </th>
                      <th class="text-right">
                        Tax
                      </th>
                      <th class="text-right">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody align="right">
                    @for (orderDetail of order?.orderInvoice?.orderDetails; track orderDetail) {
                    <tr>
                      <td>{{getPropertyCode(orderDetail)}}</td>
                      <td pTooltip="{{order?.createDate | date:'MM-dd-yyyy hh:mm a'}}">{{order?.createDate |
                        date:'MM-dd-yyyy'}}</td>
                      <td>{{orderDetail?.name}}</td>
                      <td>{{orderDetail?.quantity}}</td>
                      <td style="text-align: right;">{{orderDetail?.listPrice | currency : 'USD'}}
                      </td>
                      <td style="text-align: right;">{{orderDetail.listPriceAdjustmentAmount | currency : 'USD' :
                        'symbol' : '1.2-2'}}
                      </td>
                      <td style="text-align: right;">{{(orderDetail?.subTotal) | currency : 'USD'}}
                      </td>
                      <td style="text-align: right;">{{orderDetail?.tax | currency : 'USD'}}</td>
                      <td style="text-align: right;">{{orderDetail?.total | currency : 'USD'}}</td>
                    </tr>
                    }
                    <tr>

                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <b>
                          Sub Total :
                        </b>
                      </td>
                      <td class="text-right">
                        <b>{{order?.orderInvoice?.ttlExpense | currency : 'USD'}}</b>
                      </td>
                      <td class="text-right">
                        <b>{{order?.orderInvoice?.ttlTax | currency : 'USD'}}</b>
                      </td>
                      <td class="text-right">
                        <b>{{order?.orderInvoice?.ttlExpenseWithTax | currency : 'USD'}}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="10"></td>


                    </tr>

                    <tr>
                      <td colspan="8" class="text-right">
                        <b>
                          Total Amount :
                        </b>
                      </td>
                      <td class="text-right">
                        <b>
                          {{order?.orderInvoice?.ttlExpense | currency : 'USD'}}
                        </b>
                      </td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <td colspan="8" class="text-right">
                        <b>
                          Total Taxes :
                        </b>
                      </td>
                      <td class="text-right">
                        <b>
                          {{order?.orderInvoice?.ttlTax | currency : 'USD'}}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="8" class="text-right">
                        <b>
                          Grand Total :
                        </b>
                      </td>
                      <td class="text-right">
                        <b>
                          {{order?.orderInvoice?.ttlExpenseWithTax | currency : 'USD'}}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="10"></td>
                    </tr>
                    @for (orderInvoiceDetail of order?.orderInvoice?.orderInvoiceDetails; track orderInvoiceDetail; let
                    i = $index) {
                    <tr>
                      @if (isPayment(orderInvoiceDetail) && orderInvoiceDetail?.description == null) {
                      <td class="text-right" colspan="8">
                        <b>{{orderInvoiceDetail?.description}}</b>
                      </td>
                      }
                      @if (isPayment(orderInvoiceDetail) && orderInvoiceDetail?.description != null &&
                      !orderInvoiceDetail?.description.includes('CREDIT CARD DECLINED')) {
                      <td class="text-right" colspan="8">
                        <b>{{orderInvoiceDetail?.description}}</b>
                      </td>
                      }
                      @if (isPayment(orderInvoiceDetail) && orderInvoiceDetail?.description == null) {
                      <td class="text-right">
                        <b>{{orderInvoiceDetail?.amount | currency : 'USD'}}</b>
                      </td>
                      }
                      @if (isPayment(orderInvoiceDetail) && orderInvoiceDetail?.description != null &&
                      !orderInvoiceDetail?.description.includes('CREDIT CARD DECLINED')) {
                      <td class="text-right">
                        <b>{{orderInvoiceDetail?.amount | currency : 'USD'}}</b>
                      </td>
                      }
                    </tr>
                    }
                    <tr>
                      <td colspan="10"></td>
                    </tr>

                    <tr>
                      <td colspan="8" class="text-right">
                        <b>
                          Outstanding Balance :
                        </b>
                      </td>
                      <td class="text-right">
                        <b>
                          {{(order?.orderInvoice?.ttlDue) | currency : 'USD'}}
                        </b>
                      </td>
                    </tr>

                    <tr></tr>

                    <!-- <tr *ngIf="order?.orderInvoice?.orderInvoiceDetails.length > 0">
                  <td colspan="5">
                    {{order?.orderInvoice?.orderInvoiceDetails[0]?.description}} {{reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.createDate | date:'MM-dd-yyyy'}} :
                  </td>
                  <td>
                    (${{order?.orderInvoice?.orderInvoiceDetails[0]?.amount}})
                  </td>
                </tr>
                <tr *ngIf="order?.orderInvoice?.orderInvoiceDetails[0]?.amount == undefined">
                  <td colspan="5">
                    Payments received as of {{order?.createDate | date:'MM-dd-yyyy'}}
                  </td>
                  <td>
                    ($0.00)
                  </td>
                </tr> -->
                    <!-- Payments received as of  -->
                    <!-- <tr></tr>

                <tr>
                  <td colspan="5">
                    <b>
                      Outstanding balance :
                    </b>
                  </td>
                  <td>
                    <b>
                      {{grandTotals + reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.amount | currency : 'USD'}}
                    </b>
                  </td>
                </tr> -->
                    <tr>
                      <td colspan="9" class="text-start">
                        <b style="font-size: 16px; color:#505050">
                          Payment due dates
                        </b>
                      </td>
                    </tr>
                    @for (orderInvoiceDetail of order?.orderInvoice?.orderInvoiceDetails; track orderInvoiceDetail; let
                    i = $index) {
                    <tr>
                      @if (orderInvoiceDetail?.type == 1) {
                      <td colspan="8">
                        {{orderInvoiceDetail?.description}}
                      </td>
                      }
                      @if (orderInvoiceDetail?.type == 1) {
                      <td>
                        {{orderInvoiceDetail?.amount | currency : 'USD'}}
                      </td>
                      }
                    </tr>
                    }

                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-6">
              <!-- <ul class="list-group list-group-horizontal mb-3 lightbluebtn">
          <li class="list-group-item border-radius w-100">
            <ul class="d-flex flex-column w-100 m-0 list-unstyled gap-2">
              <li class="mr-2"><a href="#">View Contract</a></li>
              <li _ngcontent-niq-c450=""><a href="#">View Invoice</a></li>
            </ul>
          </li>
        </ul> -->
            </div>
          </div>
        </div>
        <div class="col-lg-12 p-0">
          <div class="payment paymentTable">
            <div class="title border-bottom-1 titleblue">
              <h4 class="m-0 text-black fw-bold">
                Payment
              </h4>
            </div>
            <div class="table-responsive-xl paymentable">
              @if (paymentList.length > 0 && isLoadPaymentList) {
              <p-table [value]="paymentList" class="table table-bordered mb-3">
                <ng-template pTemplate="header">
                  <tr>
                    <!-- <th style="width:100px;">
                More
              </th> -->
                    <th style="width:80px;">
                      Apply to
                    </th>
                    <th style="width:110px;">
                      Initiated
                    </th>
                    <th style="width:110px;">
                      Received
                    </th>
                    <th style="width:90px;">
                      Amount
                    </th>
                    <th style="width:90px;">
                      Processed Amount
                    </th>
                    <th style="width:100px;">
                      Type
                    </th>
                    <th style="width:130px;">
                      Name
                    </th>
                    <th style="width:80px;">
                      Chk#
                    </th>
                    <th style="width:90px;">
                      Conf#
                    </th>
                    <th style="width:150px;">
                      Deposit A/C#
                    </th>
                    <th style="width:130px;">
                      Trx
                    </th>
                    <th style="width:170px;">
                      Guest Notes
                    </th>
                    <th style="width:110px;">
                      Private Notes
                    </th>
                    <th style="width:60px;padding-left: 0;">
                      <small class="fw-bold d-block text-left text-danger">
                        <mat-icon></mat-icon>
                      </small>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-payment let-rowIndex="rowIndex">
                  @if (payment?.description != null && !payment?.description.includes('CREDIT CARD DECLINED')) {
                  <tr (click)="highlightPaymentAttemptFor(payment)" style="cursor: pointer;">
                    <!-- <td class="name-row">
                      <div class="table-row">
                        <select name="newurl2" class="form-select">
                          <option value="">Select...</option>
                          <option value="">View pay src</option>
                          <option value="">View
                            pay conf
                          </option>
                          <option value="">Email paymnt rcvd</option>
                        </select>
                      </div>
                    </td> -->
                    <td class="apply-row">
                      <!-- <div class="table-row">
                <p-dropdown class="w-100" [options]="applyToList" [ngModel]="payment.reservationId" optionLabel="name"
                optionValue="value" placeholder="" ></p-dropdown>
              </div> -->
                      <span
                        pTooltip="{{getApplyToList(payment?.reservationId, 'label')}}">{{getApplyToList(payment?.reservationId)}}</span>
                    </td>
                    <td class="date-row">
                      <!-- <div class="table-row">
              <p-calendar [ngModel]="payment.effectiveDate" id="effectiveDate" >
              </p-calendar>
            </div> -->
                      {{payment.effectiveDate | date:'MM-dd-yyyy hh:mm a'}}
                    </td>
                    <td class="date-row">
                      <!-- <div class="table-row">
            <p-calendar [ngModel]="payment.paymentProcessDate" id="paymentProcessDate" >
            </p-calendar>
          </div> -->
                      {{payment?.paymentConfirm?.paymentProcessDate | date:'MM-dd-yyyy hh:mm a'}}
                    </td>
                    <td class="amount-row">
                      <!-- <div class="table-row">
          <p-inputNumber [ngModel]="payment.amount" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
        </div> -->
                      {{payment.amount | currency : 'USD'}}
                    </td>
                    <td class="amount-row">
                      <!-- <div class="table-row">
        <p-inputNumber [ngModel]="payment.amount" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
      </div> -->
                      {{payment?.paymentConfirm?.paymentProcessAmount | currency : 'USD'}}
                    </td>
                    <td class="type-row">
                      <!-- <div class="table-row">
      <p-dropdown class="w-100" [options]="paymentReceivedTypes" [ngModel]="payment.paymentType" optionLabel="name"
      optionValue="value" placeholder="" ></p-dropdown>
    </div> -->
                      {{getPaymentReceivedType(payment?.paymentConfirm?.paymentType)}}
                    </td>
                    <td class="name-row">
                      <!-- <div class="table-row">
    <input [ngModel]="payment.billingName" id="billingName" type="text" pInputText>
  </div> -->
                      {{payment?.paymentConfirm?.billingName}}
                    </td>
                    <td class="chk-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier" type="text" pInputText>
</div> -->
                      {{payment?.paymentConfirm?.paymentSourceAccountIdentifier}}
                    </td>
                    <td class="conf-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber" type="text" pInputText>
</div> -->
                      {{payment?.paymentConfirm?.paymentTransactionConfirmNumber}}
                    </td>
                    <td class="deposit-row">
                      <!-- <div class="table-row">
  <p-dropdown class="w-100" [options]="paymentDepositTypes" [ngModel]="payment.paymentProceedsDepositedToAccountIdentifier" optionLabel="name"
  optionValue="value" placeholder="" ></p-dropdown>
</div> -->
                      {{getPaymentDepositType(payment?.paymentConfirm?.paymentProceedsDepositedToAccountIdentifier)}}
                    </td>
                    <td class="trx-row">
                      <!-- <div class="table-row">
  <p-dropdown class="w-100" [options]="invoiceDetailTypes" [ngModel]="payment.type" optionLabel="name"
  optionValue="value" placeholder="" ></p-dropdown>
</div> -->
                      {{getTypeName(payment.type)}}
                    </td>
                    <td class="guestnotes-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.description" id="description" type="text" pInputText>
</div> -->
                      {{payment.description}}
                    </td>
                    <td class="privatenotes-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.privateNotes" id="privateNotes" type="text" pInputText>
</div> -->
                      {{payment.privateNotes}}
                    </td>
                    <td class="lastcheck-row">
                      <div class="form-check lastcheckbox">
                        <!-- <input class="form-check-input" type="checkbox" value=""
    id="flexCheckDefault" /> -->
                        <a (click)="openPopUpPaymentSource(payment,$event)">
                          <i class="pi pi-pencil" aria-hidden="true"
                            style="color:blue; font-size:100%; padding-right:10px;"></i>
                        </a>
                        @if (isVoidAllowed(payment)) {
                        <a style="color:blue; font-size:100%; padding-right:10px;"
                          (click)="voidPayment(payment,$event)">
                          Void
                        </a>
                        }
                        @if (isSplitAllowed(payment)) {
                        <a style="color:blue; font-size:100%; padding-right:10px;"
                          (click)="splitPayment(payment,$event)">
                          Split
                        </a>
                        }
                        <!-- <a (click)="openPopUpPaymentSource()">
    <i class="pi pi-send" aria-hidden="true" style="color:blue; font-size:100%; padding-right:10px;"></i>
  </a> -->
                      </div>
                    </td>
                  </tr>
                  }
                  @if (payment?.description == null) {
                  <tr>
                    <!-- <td class="name-row">
    <div class="table-row">
      <select name="newurl2" class="form-select">
        <option value="">Select...</option>
        <option value="">View pay src</option>
        <option value="">View
          pay conf
        </option>
        <option value="">Email paymnt rcvd</option>
      </select>
    </div>
  </td> -->
                    <td class="apply-row">
                      <!-- <div class="table-row">
    <p-dropdown class="w-100" [options]="applyToList" [ngModel]="payment.reservationId" optionLabel="name"
    optionValue="value" placeholder="" ></p-dropdown>
  </div> -->
                      <span
                        pTooltip="{{getApplyToList(payment?.reservationId, 'label')}}">{{getApplyToList(payment?.reservationId)}}</span>
                    </td>
                    <td class="date-row" pTooltip="{{payment.effectiveDate | date:'MM-dd-yyyy hh:mm a'}}">
                      <!-- <div class="table-row">
  <p-calendar [ngModel]="payment.effectiveDate" id="effectiveDate" >
  </p-calendar>
</div> -->
                      {{payment.effectiveDate | date:'MM-dd-yyyy'}}
                    </td>
                    <td class="date-row">
                      <!-- <div class="table-row">
  <p-calendar [ngModel]="payment.paymentProcessDate" id="paymentProcessDate" >
  </p-calendar>
</div> -->
                      {{payment?.paymentConfirm?.paymentProcessDate | date}}
                    </td>
                    <td class="amount-row">
                      <!-- <div class="table-row">
  <p-inputNumber [ngModel]="payment.amount" [minFractionDigits]="0" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
  </p-inputNumber>
</div> -->
                      {{payment.amount | currency : 'USD'}}
                    </td>
                    <td class="amount-row">
                      @if (payment?.paymentConfirm?.paymentProcessAmount) {
                        <span>{{payment?.paymentConfirm?.paymentProcessAmount | currency : 'USD'}}</span>
                      }
                    </td>
                    <td class="type-row">
                      <!-- <div class="table-row">
  <p-dropdown class="w-100" [options]="paymentReceivedTypes" [ngModel]="payment.paymentType" optionLabel="name"
  optionValue="value" placeholder="" ></p-dropdown>
</div> -->
                      {{getPaymentReceivedType(payment?.paymentConfirm?.paymentType)}}
                    </td>
                    <td class="name-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.billingName" id="billingName" type="text" pInputText>
</div> -->
                      {{payment?.paymentConfirm?.billingName}}
                    </td>
                    <td class="chk-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier" type="text" pInputText>
</div> -->
                      {{payment?.paymentConfirm?.paymentSourceAccountIdentifier}}
                    </td>
                    <td class="conf-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber" type="text" pInputText>
</div> -->
                      {{payment?.paymentConfirm?.paymentTransactionConfirmNumber}}
                    </td>
                    <td class="deposit-row">
                      <!-- <div class="table-row">
  <p-dropdown class="w-100" [options]="paymentDepositTypes" [ngModel]="payment.paymentProceedsDepositedToAccountIdentifier" optionLabel="name"
  optionValue="value" placeholder="" ></p-dropdown>
</div> -->
                      {{getPaymentDepositType(payment?.paymentConfirm?.paymentProceedsDepositedToAccountIdentifier)}}
                    </td>
                    <td class="trx-row">
                      <!-- <div class="table-row">
  <p-dropdown class="w-100" [options]="invoiceDetailTypes" [ngModel]="payment.type" optionLabel="name"
  optionValue="value" placeholder="" ></p-dropdown>
</div> -->
                      {{getTypeName(payment.type)}}
                    </td>
                    <td class="guestnotes-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.description" id="description" type="text" pInputText>
</div> -->
                      {{payment.description}}
                    </td>
                    <td class="privatenotes-row">
                      <!-- <div class="table-row">
  <input [ngModel]="payment.privateNotes" id="privateNotes" type="text" pInputText>
</div> -->
                      {{payment.privateNotes}}
                    </td>
                    <td class="lastcheck-row">
                      <div class="form-check lastcheckbox">
                        <!-- <input class="form-check-input" type="checkbox" value=""
    id="flexCheckDefault" /> -->
                        <a (click)="openPopUpPaymentSource(payment,$event)">
                          <i class="pi pi-pencil" aria-hidden="true"
                            style="color:blue; font-size:100%; padding-right:10px;"></i>
                        </a>
                        <!-- <a (click)="openPopUpPaymentSource()">
    <i class="pi pi-send" aria-hidden="true" style="color:blue; font-size:100%; padding-right:10px;"></i>
  </a> -->
                      </div>
                    </td>
                  </tr>
                  }
                  @if (paymentList.length == (rowIndex + 1)) {
                  <tr [formGroup]="form3">
                    <td class="apply-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" [options]="applyToList" formControlName="reservationId"
                          optionValue="value" optionLabel="name" placeholder="" appendTo="body">
                          <ng-template pTemplate="item" let-item>
                            <span>{{item.label}}</span>
                          </ng-template>
                          <ng-template pTemplate="selectedItem" let-item>
                            <span>{{item.name}}</span>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </td>
                    <td class="date-row">
                      <div class="table-row">
                        <p-calendar formControlName="effectiveDate" id="effectiveDate" appendTo="body">
                        </p-calendar>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="date-row">
                      <div class="table-row">
                        <p-calendar formControlName="paymentProcessDate" id="paymentProcessDate" appendTo="body">
                        </p-calendar>
                      </div>
                    </td>
                    <td class="amount-row">
                      <div class="table-row">
                        <p-inputNumber formControlName="amount" [minFractionDigits]="2" inputId="currency-us"
                          mode="currency" currency="USD" locale="en-US">
                        </p-inputNumber>
                        @for (validation of validationMessages4.amount; track validation) {
                        <span class="table-row-error">
                          @if (form3.get('amount').hasError(validation.type) && (form3.get('amount').dirty ||
                          form3.get('amount').touched)) {
                          <small class="p-invalid">{{validation.message}}
                          </small>
                          }
                        </span>
                        }
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="amount-row"></td>
                    <td formGroupName="paymentConfirm" class="type-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" formControlName="paymentType" [options]="paymentReceivedTypes"
                          optionLabel="name" optionValue="value" placeholder="" appendTo="body"></p-dropdown>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="name-row">
                      <div class="table-row">
                        <input formControlName="billingName" id="billingName" type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="chk-row">
                      <div class="table-row">
                        <input formControlName="paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier"
                          type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="conf-row">
                      <div class="table-row">
                        <input formControlName="paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber"
                          type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="deposit-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" formControlName="paymentProceedsDepositedToAccountIdentifier"
                          [options]="paymentDepositTypes" optionLabel="name" optionValue="value" placeholder=""
                          appendTo="body"></p-dropdown>
                      </div>
                    </td>
                    <td class="trx-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" [options]="invoiceDetailTypes" formControlName="type"
                          optionLabel="name" optionValue="value" placeholder="" appendTo="body"></p-dropdown>
                        @for (validation of validationMessages4.type; track validation) {
                        <span class="table-row-error">
                          @if (form3.get('type').hasError(validation.type) && (form3.get('type').dirty ||
                          form3.get('type').touched)) {
                          <small class="p-invalid">{{validation.message}}
                          </small>
                          }
                        </span>
                        }
                      </div>
                    </td>
                    <td class="guestnotes-row">
                      <div class="table-row">
                        <input formControlName="description" id="description" type="text" pInputText>
                      </div>
                    </td>
                    <td class="privatenotes-row">
                      <div class="table-row">
                        <input formControlName="privateNotes" id="privateNotes" type="text" pInputText>
                      </div>
                    </td>
                    <td class="lastcheck-row">
                      <div class="form-check lastcheckbox">
                        <!-- <input class="form-check-input" type="checkbox" value=""
        id="flexCheckDefault" /> -->
                        <a class="text-link" [class.text-muted]="addingOrderInvoiceDetail"
                          [class.pe-none]="addingOrderInvoiceDetail" [attr.aria-busy]="addingOrderInvoiceDetail"
                          [attr.aria-disabled]="addingOrderInvoiceDetail" (click)="addOrderInvoiceDetail(payment)">
                          {{ addingOrderInvoiceDetail ? 'Adding…' : 'add' }}
                        </a>
                      </div>
                    </td>
                  </tr>
                  }
                </ng-template>
              </p-table>
              }
              @if ((paymentList == null || paymentList == undefined || paymentList.length == 0) && !isLoadPaymentList) {
              <table class="table table-bordered mb-3">
                <!-- <ng-template pTemplate="header"> -->
                <tr>
                  <!-- <th style="width:100px;">
      More
    </th> -->
                  <th style="width:80px;">
                    Apply to
                  </th>
                  <th style="width:110px;">
                    Initiated
                  </th>
                  <th style="width:110px;">
                    Received
                  </th>
                  <th style="width:90px;">
                    Amount
                  </th>
                  <th style="width:100px;">
                    Type
                  </th>
                  <th style="width:130px;">
                    Name
                  </th>
                  <th style="width:80px;">
                    Chk#
                  </th>
                  <th style="width:90px;">
                    Conf#
                  </th>
                  <th style="width:150px;">
                    Deposit A/C#
                  </th>
                  <th style="width:130px;">
                    Trx
                  </th>
                  <th style="width:170px;">
                    Guest Notes
                  </th>
                  <th style="width:110px;">
                    Private Notes
                  </th>
                  <th style="width:60px;padding-left: 0;">
                    <small class="fw-bold d-block text-left text-danger">
                      <mat-icon></mat-icon>
                    </small>
                  </th>
                </tr>
                <!-- </ng-template> -->
                <!-- <ng-template pTemplate="body"> -->
                <tbody>
                  <tr [formGroup]="form3">
                    <td class="apply-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" [options]="applyToList" formControlName="reservationId"
                          optionValue="value" optionLabel="name" placeholder="" appendTo="body">
                          <ng-template pTemplate="item" let-item>
                            <span>{{item.label}}</span>
                          </ng-template>
                          <ng-template pTemplate="selectedItem" let-item>
                            <span>{{item.name}}</span>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </td>
                    <td class="date-row">
                      <div class="table-row">
                        <p-calendar formControlName="effectiveDate" id="effectiveDate" appendTo="body">
                        </p-calendar>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="date-row">
                      <div class="table-row">
                        <p-calendar formControlName="paymentProcessDate" id="paymentProcessDate" appendTo="body">
                        </p-calendar>
                      </div>
                    </td>
                    <td class="amount-row">
                      <div class="table-row">
                        <p-inputNumber formControlName="amount" [minFractionDigits]="2" inputId="currency-us"
                          mode="currency" currency="USD" locale="en-US">
                        </p-inputNumber>
                        @for (validation of validationMessages4.amount; track validation) {
                        <span class="table-row-error">
                          @if (form3.get('amount').hasError(validation.type) && (form3.get('amount').dirty ||
                          form3.get('amount').touched)) {
                          <small class="p-invalid">{{validation.message}}
                          </small>
                          }
                        </span>
                        }
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="type-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" formControlName="paymentType" [options]="paymentReceivedTypes"
                          optionLabel="name" optionValue="value" placeholder="" appendTo="body"></p-dropdown>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="name-row">
                      <div class="table-row">
                        <input formControlName="billingName" id="billingName" type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="chk-row">
                      <div class="table-row">
                        <input formControlName="paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier"
                          type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="conf-row">
                      <div class="table-row">
                        <input formControlName="paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber"
                          type="text" pInputText>
                      </div>
                    </td>
                    <td formGroupName="paymentConfirm" class="deposit-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" formControlName="paymentProceedsDepositedToAccountIdentifier"
                          [options]="paymentDepositTypes" optionLabel="name" optionValue="value" placeholder=""
                          appendTo="body"></p-dropdown>
                      </div>
                    </td>
                    <td class="trx-row">
                      <div class="table-row">
                        <p-dropdown class="w-100" [options]="invoiceDetailTypes" formControlName="type"
                          optionLabel="name" optionValue="value" placeholder="" appendTo="body"></p-dropdown>
                        @for (validation of validationMessages4.type; track validation) {
                        <span class="table-row-error">
                          @if (form3.get('type').hasError(validation.type) && (form3.get('type').dirty ||
                          form3.get('type').touched)) {
                          <small class="p-invalid">{{validation.message}}
                          </small>
                          }
                        </span>
                        }
                      </div>
                    </td>
                    <td class="guestnotes-row">
                      <div class="table-row">
                        <input formControlName="description" id="description" type="text" pInputText>
                      </div>
                    </td>
                    <td class="privatenotes-row">
                      <div class="table-row">
                        <input formControlName="privateNotes" id="privateNotes" type="text" pInputText>
                      </div>
                    </td>
                    <td class="lastcheck-row">
                      <div class="form-check lastcheckbox">
                        <!-- <input class="form-check-input" type="checkbox" value=""
        id="flexCheckDefault" /> -->
                        <a class="text-link" [class.text-muted]="addingOrderInvoiceDetail"
                          [class.pe-none]="addingOrderInvoiceDetail" [attr.aria-busy]="addingOrderInvoiceDetail"
                          [attr.aria-disabled]="addingOrderInvoiceDetail" (click)="addOrderInvoiceDetail(payment)">
                          {{ addingOrderInvoiceDetail ? 'Adding…' : 'add' }}
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              }
            </div>
          </div>
        </div>
        <div class="col-lg-12 px-0">
          <div class="payment-attempts mt-3">
            <div class="title border-bottom-1 mb-2 titleblue d-flex align-items-center gap-2">
              <h4 class="m-0 text-black fw-bold">
                Payment attempts
              </h4>
              <button type="button" (click)="showPaymentHelp = true" title="How does this work?"
                style="background:none; border:none; padding:0; cursor:pointer; color:#2563eb; font-size:1rem; line-height:1;">
                <i class="pi pi-info-circle"></i>
              </button>
            </div>
            <div class="table-responsive-xl">
              <table class="table table-bordered mb-3">
                <thead align="center">
                  <tr>
                    <th>
                      Date
                    </th>
                    <th>
                      Amount
                    </th>
                    <th>
                      Type
                    </th>
                    <th>
                      Name
                    </th>
                    <th>
                      Check#/Id
                    </th>
                    <th>
                      Result
                    </th>
                    <th>
                      Request
                    </th>
                    <th>
                      Change Log
                    </th>
                  </tr>
                </thead>
                <tbody align="center">
                  @for (paymentAttempt of order?.paymentAttempts; track paymentAttempt; let i = $index) {
                  <tr #paymentAttemptRow
                    [ngClass]="{'payment-attempt-highlight': i === highlightedPaymentAttemptIndex}">
                    <td>
                      <span>
                        {{paymentAttempt?.paymentProcessDate | date}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{paymentAttempt?.paymentProcessAmount}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{getPaymentTypeName(paymentAttempt)}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{paymentAttempt?.billingName}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{paymentAttempt?.paymentSourceAccountIdentifier}}
                      </span>
                    </td>
                    @if (paymentAttempt?.paymentResultIndicator != 'D' && paymentAttempt?.paymentResultIndicator != 'E')
                    {
                    <td class="bg-success">
                      <span>
                        {{paymentAttempt?.paymentResultIndicator}}
                      </span>
                    </td>
                    }
                    @if (paymentAttempt?.paymentResultIndicator == 'D' || paymentAttempt?.paymentResultIndicator == 'E')
                    {
                    <td style="background-color: red;">
                      <span>
                        {{paymentAttempt?.paymentResultIndicator}}
                      </span>
                    </td>
                    }
                    <td>
                      <span>
                        {{paymentAttempt?.paymentCreditCardRequestedTransactionType}}
                      </span>
                      @if (isAwaitingCapture(paymentAttempt)) {
                      <span
                        style="background:#ffe066; color:#664d00; padding:2px 6px; border-radius:3px; margin-left:6px; font-size:0.75rem; font-weight:600;">
                        Awaiting Capture
                      </span>
                      }
                      <!-- Reconcile button: visible when (a) the row is AO+A awaiting capture, or
                     (b) the scheduler attempted PC and the gateway rejected it (PC+D / PC+E).
                     The admin clicks this AFTER capturing the auth manually in the
                     Authorize.net dashboard so the DB is brought in sync. -->
                      @if (canReconcileCaptured(paymentAttempt)) {
                      <button type="button" (click)="onReconcileCaptured(paymentAttempt)"
                        [disabled]="reconcilingPaymentConfirmId === paymentAttempt?.paymentConfirmId" style="margin-left:8px; font-size:0.75rem; padding:2px 8px; border-radius:3px;
                                 border:1px solid #2563eb; background:#2563eb; color:#fff; cursor:pointer;">
                        {{ reconcilingPaymentConfirmId === paymentAttempt?.paymentConfirmId
                        ? 'Reconciling…' : 'Reconcile Captured' }}
                      </button>
                      }
                      <!-- Capture & Sync: visible for AO+A rows awaiting capture AND for PC+D/PC+E
                     rows where the scheduler attempted capture and the gateway rejected it.
                     Captures the prior auth through our app (POST capturePriorAuthAndSync)
                     rather than requiring the admin to go to Authorize.net first. -->
                      @if (canCaptureAndSync(paymentAttempt)) {
                      <button type="button" (click)="onCaptureAndSync(paymentAttempt)"
                        [disabled]="capturingPaymentConfirmId === paymentAttempt?.paymentConfirmId" style="margin-left:8px; font-size:0.75rem; padding:2px 8px; border-radius:3px;
                                 border:1px solid #059669; background:#059669; color:#fff; cursor:pointer;">
                        {{ capturingPaymentConfirmId === paymentAttempt?.paymentConfirmId
                        ? 'Capturing…' : 'Capture & Sync' }}
                      </button>
                      }
                    </td>
                    <td colspan="4" class="text-start textsm">
                      <!-- <span class="d-block">
                {{paymentAttempt?.changeLog}}
              </span> -->
                      <div [innerHTML]="filterText(paymentAttempt?.changeLog)"></div>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row mx-0 align-items-center justify-content-between" style="background-color: #F0F2FF;">
        <div class="col-sm-12 p-0 leftbtn">
          <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 p-2">
            <button type="button" class="btn btn-primary" [disabled]="formLoading" (click)="updateReservations()">Update</button>
            <button type="button" class="btn btn-light ml-2" [disabled]="formLoading" [mat-dialog-close]="true"
              (click)="gotoReservation()">Cancel</button>
            <!-- <button type="button" class="btn btn-primary ml-2" (click)="openCreateReservationPopUp()">Add Reservation</button> -->
          </div>
        </div>
      </div>

    </div>
  </mat-tab>
  @if (reservations.length > 0) {
  <mat-tab label="Email & Text">
    <!--
    parameter passed and stage based on that SMS or mail template is sent
    now that we have live merge of template we dont need custom message sending from custom buttons
    -->
    <!-- <button pButton class="btn-addt p-button" (click)="sendGuestComm( 100)">Send welCome Checkin</button>
    <button pButton class="btn-addt p-button" (click)="sendGuestComm(200)">Send Day After Checkin</button>
    <button pButton class="btn-addt p-button" (click)="sendGuestComm(300)">Send Day Before Checkout</button>
    <button pButton class="btn-addt p-button" (click)="sendGuestComm(400)">Send Day After Checkout</button>
    <button pButton class="btn-addt p-button" (click)="sendGuestComm(500)">Send Week After Checkout</button>-->
    <app-inbox-list-vertical [msgTopic]="100" [msgTopicId]="reservations[0]?.reservationId"
      [order]="order" [orderId]="orderId" [reservations]="reservations"
      [mobilePhone]="reservations[0]?.primaryMobilePhone ? reservations[0].primaryMobilePhone : reservations[0]?.guestProfile?.mobilePhone"></app-inbox-list-vertical>
    <!-- <app-inbox-list-guest *ngIf="isReservationLoaded" [msgTopic]="100" [msgTemplateData]="msgTemplateData" [msgTopicId]="reservations[0]?.reservationId" [orderId]="orderId"></app-inbox-list-guest> -->
  </mat-tab>
  }
  <mat-tab label="History">
    <div class="mt-3 change-log">
      <div class="title border-bottom-1 mb-2 titleblue d-flex justify-content-between align-items-center">
        <h4 class="m-0 text-black fw-bold">
          Rate Log Output
        </h4>
        <div class="d-flex align-items-center gap-2">
          <button pButton type="button" label="Sync with Yieldmax" icon="pi pi-sync"
            (click)="syncOrderWithYieldmax(order?.orderId)" class="p-button-sm"></button>
        </div>
      </div>
      <p-table #dt [value]="rateLogOutput" [responsiveLayout]="'scroll'" styleClass="p-datatable-striped"
        [sortMode]="'multiple'" [style]="{ height: '500px' }" scrollHeight="500px">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'logmanId'">Log ID
              <p-sortIcon [field]="logmanId"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'analyzedDate'">Date
              <p-sortIcon [field]="analyzedDate"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'eventName'">Event
              <p-sortIcon [field]="eventName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'inputValue'">Input Value
              <p-sortIcon [field]="inputValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'inputValueName'">Input Value Name
              <p-sortIcon [field]="inputValueName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'changeValue'">Change Value
              <p-sortIcon [field]="changeValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'changeAmount'">Change Amount
              <p-sortIcon [field]="changeAmount"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'outputValue'">Output Value
              <p-sortIcon [field]="outputValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'outputValueName'">Output Value Name
              <p-sortIcon [field]="outputValueName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'message'">Message
              <p-sortIcon [field]="message"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'methodName'">Method
              <p-sortIcon [field]="methodName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'referenceId'">Reference ID
              <p-sortIcon [field]="referenceId"></p-sortIcon>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log let-rowIndex="rowIndex">
          @if (!log.isBlankRow) {
          <tr>
            <td>{{ log.logmanId }}</td>
            <td>{{ log.analyzedDate }}</td>
            <td>{{ log.eventName }}</td>
            <td>{{ log.inputValue | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td>{{ log.inputValueName }}</td>
            <td>{{ log.changeValue }}</td>
            <td>{{ log.changeAmount | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td [ngClass]="{
					  'red-background': log.rateLogSeverity === 'RU',
					  'green-background': log.rateLogSeverity === 'RD',
					  'blue-background': log.rateLogSeverity === 'NA'
				  }">{{ log.outputValue | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
            <td>{{ log.outputValueName }}</td>
            <td>{{ log.message }}</td>
            <td>{{ log.methodName }}</td>
            <td>{{ log.referenceId }}</td>
          </tr>
          }
          @if (log.isBlankRow) {
          <tr class="blank-row">
            <td colspan="12"></td>
          </tr>
          }
        </ng-template>
      </p-table>

      <div class="title border-bottom-1 mb-2 titleblue">
        <h4 class="m-0 text-black fw-bold">
          Rate Los Log Output
        </h4>
      </div>
      <p-table #dt [value]="rateLosLogOutput" [responsiveLayout]="'scroll'" styleClass="p-datatable-striped"
        [sortMode]="'multiple'" [style]="{ height: '500px' }" scrollHeight="500px">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'logmanId'">Log ID
              <p-sortIcon [field]="logmanId"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'analyzedDate'">Date
              <p-sortIcon [field]="analyzedDate"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'eventName'">Event
              <p-sortIcon [field]="eventName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'inputValue'">Input Value
              <p-sortIcon [field]="inputValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'inputValueName'">Input Value Name
              <p-sortIcon [field]="inputValueName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'changeValue'">Change Value
              <p-sortIcon [field]="changeValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'changeAmount'">Change Amount
              <p-sortIcon [field]="changeAmount"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'outputValue'">Output Value
              <p-sortIcon [field]="outputValue"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'outputValueName'">Output Value Name
              <p-sortIcon [field]="outputValueName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'message'">Message
              <p-sortIcon [field]="message"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'methodName'">Method
              <p-sortIcon [field]="methodName"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'referenceId'">Reference ID
              <p-sortIcon [field]="referenceId"></p-sortIcon>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log let-rowIndex="rowIndex">
          @if (!log.isBlankRow) {
          <tr>
            <td>{{ log.logmanId }}</td>
            <td>{{ log.analyzedDate }}</td>
            <td>{{ log.eventName }}</td>
            <td>{{ log.inputValue | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td>{{ log.inputValueName }}</td>
            <td>{{ log.changeValue || 'NA' }}</td>
            <td>{{ log.changeAmount | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td [ngClass]="{
					  'red-background': log.rateLogSeverity === 'RU',
					  'green-background': log.rateLogSeverity === 'RD',
					  'blue-background': log.rateLogSeverity === 'NA'
				  }">{{ log.outputValue | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
            <td>{{ log.outputValueName }}</td>
            <td>{{ log.message }}</td>
            <td>{{ log.methodName }}</td>
            <td>{{ log.referenceId }}</td>
          </tr>
          }
          @if (log.isBlankRow) {
          <tr class="blank-row">
            <td colspan="12"></td>
          </tr>
          }
        </ng-template>
      </p-table>

      <div class="title border-bottom-1 mb-2 mt-2 titleblue">
        <h4 class="m-0 text-black fw-bold">
          Fees Added on YM Rate
        </h4>
      </div>
      <p-table #dt [value]="rateFeesDetails" [responsiveLayout]="'scroll'" styleClass="p-datatable-striped"
        [sortMode]="'multiple'" [style]="{ height: '500px' }" scrollHeight="500px">
        <ng-template pTemplate="header">

          <tr>
            <th [pSortableColumn]="'orderProductId'">Product Id
              <p-sortIcon [field]="orderProductId"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'name'">Name
              <p-sortIcon [field]="name"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'listPrice'">List Price
              <p-sortIcon [field]="listPrice"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'quantity'">Qty
              <p-sortIcon [field]="quantity"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'subTotal'">Sub Total
              <p-sortIcon [field]="subTotal"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'tax'">Tax
              <p-sortIcon [field]="tax"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'total'">Total
              <p-sortIcon [field]="total"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log let-rowIndex="rowIndex">
          <tr>
            <td>{{ log.orderProductId }}</td>
            <td>{{ log.name }}</td>
            <td>{{ log.listPrice | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td>{{ log.quantity }}</td>
            <td>{{ log.subTotal | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td>{{ log.tax | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td>{{ log.total | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
          </tr>
        </ng-template>
      </p-table>

    </div>
    @if (order?.reservations.length > 0) {
    <app-audit-enriched-list
      [auditUrl]="'reservation/' + order?.reservations[0]?.reservationId + '/audit-full-history'"></app-audit-enriched-list>
    }

    <!-- ===== PROMOTION OFFER CARD (read-only for now) ===== -->
    @if (promotionOffer) {
    <div class="mt-3 mb-3" style="border: 1px solid #d4c5a4; border-radius: 6px; background: #fffaf0; padding: 12px;">
      <div class="d-flex justify-content-between align-items-center"
        style="border-bottom: 1px solid #e0d4b6; padding-bottom: 6px; margin-bottom: 8px;">
        <h4 class="m-0 fw-bold" style="color: #8a6d3b;">
          <i class="pi pi-gift" style="margin-right: 6px;"></i> Promotion Offer
          <i class="pi pi-info-circle" style="margin-left: 6px; color: #1a73e8; cursor: pointer; font-size: 14px;"
             title="What is the Promotion Offer? Click to learn how it works."
             (click)="promotionHelpVisible = true"></i>
        </h4>
        <span style="font-size: 12px; padding: 3px 10px; border-radius: 12px; font-weight: bold;" [ngStyle]="{
                'background-color': promotionOffer.status === 'OFFERED'           ? '#fff3cd' :
                                    promotionOffer.status === 'ACCEPTED'          ? '#d4edda' :
                                    promotionOffer.status === 'APPLIED'           ? '#cce5ff' :
                                    promotionOffer.status === 'PARTIALLY_APPLIED' ? '#fde2c4' :
                                    promotionOffer.status === 'DECLINED'          ? '#f8d7da' :
                                    promotionOffer.status === 'EXPIRED'           ? '#e2e3e5' : '#e2e3e5',
                'color':            promotionOffer.status === 'OFFERED'           ? '#856404' :
                                    promotionOffer.status === 'ACCEPTED'          ? '#155724' :
                                    promotionOffer.status === 'APPLIED'           ? '#004085' :
                                    promotionOffer.status === 'PARTIALLY_APPLIED' ? '#7a4a14' :
                                    promotionOffer.status === 'DECLINED'          ? '#721c24' :
                                    promotionOffer.status === 'EXPIRED'           ? '#383d41' : '#383d41'
              }">
          {{ promotionOffer.status }}
        </span>
      </div>

      <table style="width: 100%; font-size: 13px; line-height: 1.7;">
        <tr>
          <td style="width: 220px; color: #555;">Direction</td>
          <td>
            <!-- Dual-direction (added 2026-05-17): show both dates -->
            @if (promotionOffer.directions && promotionOffer.directions.length > 1) {
              <b>Day Before Arrival and/or Day After Departure</b>
              <span style="color: #888; margin-left: 6px;">
                ({{ promotionOffer.prevDate | date:'EEE M/d/yyyy' }} and/or {{ promotionOffer.nextDate | date:'EEE M/d/yyyy' }})
              </span>
            } @else {
              @if (promotionOffer.direction === 'NEXT' || (promotionOffer.directions?.[0] === 'NEXT')) { Day After Departure }
              @if (promotionOffer.direction === 'PREV' || (promotionOffer.directions?.[0] === 'PREV')) { Day Before Arrival }
              <span style="color: #888; margin-left: 6px;">({{ (promotionOffer.offerDate || promotionOffer.nextDate || promotionOffer.prevDate) | date:'EEE M/d/yyyy' }})</span>
            }
          </td>
        </tr>
        <tr>
          <td style="color: #555;">Season</td>
          <td>
            @if (promotionOffer.seasonNumber) { Season {{ promotionOffer.seasonNumber }} }
            @if (promotionOffer.effectivePct !== promotionOffer.discountPct) {
            <span style="color: #c9a800; font-size: 12px;">(discount capped from {{ promotionOffer.discountPct |
              number:'1.0-1' }}% to {{ promotionOffer.effectivePct | number:'1.0-1' }}% by owner floor)</span>
            }
          </td>
        </tr>
        <!-- Guest offer — the actual offer the guest receives -->
        <tr style="background: #e8f5e9; border-top: 1px solid #c3e6cb; border-bottom: 1px solid #c3e6cb;">
          <td style="padding: 5px 0; color: #1a5c32;"><b>Guest offer</b></td>
          <td>
            <b style="color: #27ae60; font-size: 15px;">{{ promotionOffer.effectivePct | number:'1.0-1' }}% off</b>
            <span style="color: #555; font-size: 12px; margin-left: 6px;">their current nightly rate for the extra
              night</span>
          </td>
        </tr>

        @if (promotionOffer.ownerFloorAMT) {
        <tr>
          <td style="color: #555;">Owner floor</td>
          <td>{{ promotionOffer.ownerFloorAMT | currency:'USD' }}</td>
        </tr>
        }
        <tr>
          <td style="color: #555;">Stay length</td>
          <td>{{ promotionOffer.originalNights }} → {{ promotionOffer.extendedNights }} nights</td>
        </tr>
        @if (promotionOffer.smsMsgId) {
        <tr>
          <td style="color: #555;">SMS</td>
          <td>
            <span style="color: #888;">msgId #{{ promotionOffer.smsMsgId }}</span>
            @if (promotionOffer.createDate) {
            <span style="color: #888; margin-left: 8px;">sent {{ promotionOffer.createDate | date:'M/d/yy h:mm a' }} ET</span>
            }
          </td>
        </tr>
        }
        @if (promotionOffer.expiresAt) {
        <tr>
          <td style="color: #555;">
            @if (promotionOffer.status === 'EXPIRED') { Expired } @else { Expires }
          </td>
          <td>
            @if (promotionOffer.status === 'EXPIRED') {
              <span style="color: #721c24; font-weight: 600;">
                {{ promotionOffer.expiresAt | date:'M/d/yy h:mm a' }} ET
              </span>
            } @else {
              <span [style.color]="isOfferExpiringSoon(promotionOffer.expiresAt) ? '#c0392b' : '#856404'"
                    [style.font-weight]="isOfferExpiringSoon(promotionOffer.expiresAt) ? '600' : 'normal'">
                {{ promotionOffer.expiresAt | date:'M/d/yy h:mm a' }} ET
                @if (isOfferExpiringSoon(promotionOffer.expiresAt)) {
                  <span style="margin-left: 6px; font-size: 11px;">(expiring soon)</span>
                }
              </span>
            }
          </td>
        </tr>
        }
        @if (promotionOffer.acceptedDate) {
        <tr>
          <td style="color: #555;">Guest accepted</td>
          <td>{{ promotionOffer.acceptedDate | date:'M/d/yy h:mm a' }}</td>
        </tr>
        }
        @if (promotionOffer.appliedDate) {
        <tr>
          <td style="color: #555;">Applied</td>
          <td>{{ promotionOffer.appliedDate | date:'M/d/yy h:mm a' }}
            @if (promotionOffer.appliedByUserId) { <span style="color: #888;">by user #{{ promotionOffer.appliedByUserId
              }}</span> }
          </td>
        </tr>
        <!-- CC charge result — always shown after Apply for traceability -->
        <tr>
          <td style="color: #555;">Payment</td>
          <td>
            @if (promotionOffer.chargeAttempted === true && promotionOffer.chargeApproved === true) {
            <span style="color: #27ae60;">
              <i class="pi pi-check-circle"></i>
              <b> Charged {{ promotionOffer.chargeAmount | currency:'USD' }}</b>
              @if (promotionOffer.chargeCardMask) { <span style="color:#555;"> · {{ promotionOffer.chargeCardMask
                }}</span> }
              @if (promotionOffer.chargeTransactionId) { <span style="color:#888; font-size:11px;"> · Txn#{{
                promotionOffer.chargeTransactionId }}</span> }
            </span>
            } @else if (promotionOffer.chargeAttempted === true && promotionOffer.chargeApproved === false) {
            <span style="color: #c0392b;">
              <i class="pi pi-exclamation-circle"></i>
              <b> Charge declined</b>
              @if (promotionOffer.chargeErrorMessage) { — {{ promotionOffer.chargeErrorMessage }} }
            </span>
            } @else if (promotionOffer.chargeAttempted === false && promotionOffer.chargeErrorMessage) {
            <span style="color: #856404;">
              <i class="pi pi-exclamation-triangle"></i>
              {{ promotionOffer.chargeErrorMessage }}
            </span>
            } @else if (promotionOffer.chargeAttempted === false) {
            <span style="color: #888;">Not charged automatically — collect via Run Payment.</span>
            } @else {
            <span style="color: #888; font-style: italic;">No charge info recorded.</span>
            }
          </td>
        </tr>
        }
      </table>

      <div style="margin-top: 8px; font-size: 11px; color: #999; font-style: italic;">
        Guest is charged based on their reservation's nightly rate with the offer discount applied &mdash; click
        <b>Preview &amp; Apply</b> to see the exact guest-facing price breakdown including fees and tax.
      </div>

      <!-- Action row: shown only while the offer is still actionable -->
      @if (promotionOffer.status === 'OFFERED' || promotionOffer.status === 'ACCEPTED') {
      <div class="d-flex gap-2 mt-2">
        <button pButton type="button" label="Preview & Apply" icon="pi pi-check" class="p-button-sm"
          style="background: #27ae60; border-color: #27ae60;" (click)="openPromotionPreview()"></button>
        <button pButton type="button" label="Decline" icon="pi pi-times"
          class="p-button-sm p-button-secondary p-button-outlined" (click)="declinePromotionOffer()"></button>
      </div>
      }
    </div>
    }

    <!-- ===== Apply confirmation modal ===== -->
    <!-- ── Promotion Offer help / how-to popover (added 2026-05-17 per Sarah) ── -->
    <p-dialog header="About the Promotion Offer Tool" [(visible)]="promotionHelpVisible" [modal]="true"
      [style]="{width: '620px'}" [draggable]="false" [resizable]="false">
      <div style="font-size:13px; line-height:1.6; color:#333;">
        <h6 style="color:#1a73e8; margin-top:0;">What is this?</h6>
        <p>
          When a new booking comes in, the system automatically checks whether the
          night <b>before check-in</b>, the night <b>after check-out</b>, or both
          are available on the same property. If so, the guest receives a text
          offering a discount on the extra night(s).
        </p>

        <h6 style="color:#1a73e8;">Who receives the text?</h6>
        <p>
          Guests who book through the <b>Website</b> or <b>VRBO</b> and whose
          reservation matches the dynamic eligibility criteria. The text is sent
          once, shortly after the booking is confirmed.
        </p>

        <h6 style="color:#1a73e8;">What happens when the guest says YES?</h6>
        <p>
          The guest replies YES (or otherwise indicates interest). You confirm
          with them, then open this Promotion Offer card on their reservation
          and click <b>Preview & Apply</b>.
        </p>

        <h6 style="color:#1a73e8;">What does Apply do?</h6>
        <ul style="margin-top:4px; padding-left:20px;">
          <li>Re-checks availability on the adjacent night(s)</li>
          <li>Extends the reservation dates</li>
          <li>Scales the existing coupon (if any) to the new night count</li>
          <li>Adds a <b>Promotion Extension Discount</b> line to the invoice</li>
          <li>For Website / VRBO bookings, automatically charges the guest's saved card for the extra night total</li>
          <li>Notifies downstream systems (door codes, arrivals, etc.) via the standard "Dates Changed" flow</li>
        </ul>

        <h6 style="color:#1a73e8;">Dual-direction offers (new)</h6>
        <p>
          If <b>both</b> the day before and the day after are available, the SMS
          offers both — e.g. <i>"add June 30 and/or July 7 for 30% off"</i>. The
          guest can pick one, the other, or both. In the Preview dialog you'll
          see checkboxes for each available date — choose what the guest wants.
        </p>
        <p style="color:#856404; background:#fff3cd; padding:8px; border-radius:4px; font-size:12px;">
          <b>Different seasons?</b> If the two nights fall in different season
          tiers with different discount percentages, the lower of the two is
          offered for both nights (so neither night drops below its YieldMax
          floor).
        </p>

        <h6 style="color:#1a73e8;">When does the offer expire?</h6>
        <p>
          <b>72 hours</b> after it is sent. After that the offer disappears from
          this card automatically. If you apply only one direction of a
          dual-direction offer within the window, the row is marked
          <b>Partially Applied</b> — you can come back later (still inside the
          72 hours) and apply the other side too.
        </p>

        <h6 style="color:#1a73e8;">What if the card charge fails?</h6>
        <p>
          You'll see a "Charge failed" dialog with the option to extend without
          charge (Run Payment can collect manually) or cancel. No reservation
          change happens until either the charge succeeds or you confirm to
          extend without it.
        </p>

        <h6 style="color:#1a73e8;">Need help?</h6>
        <p>
          Ping Divy or Sarah on any reservation that doesn't behave as expected.
        </p>
      </div>
      <ng-template pTemplate="footer">
        <button pButton label="Got it" icon="pi pi-check" (click)="promotionHelpVisible = false"></button>
      </ng-template>
    </p-dialog>

    <p-dialog header="Confirm Promotion Apply" [(visible)]="promotionPreviewVisible" [modal]="true"
      [style]="{width: '580px'}" [draggable]="false" [resizable]="false">

      @if (promotionPreviewLoading) {
      <div class="text-center p-4">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i> Loading preview…
      </div>
      }

      @if (!promotionPreviewLoading && promotionPreview) {

      <!-- BLOCKED -->
      @if (promotionPreview.decision === 'BLOCKED') {
      <div class="p-3" style="background:#f8d7da; color:#721c24; border-radius:4px; margin-bottom:12px;">
        <b>Cannot apply:</b> {{ promotionPreview.reason }}
      </div>
      }

      <!-- Expiry notice — shown on OK so reservationist knows the deadline -->
      @if (promotionPreview.decision === 'OK' && promotionOffer?.expiresAt) {
      <div style="margin-bottom:10px; padding:6px 10px; border-radius:4px; font-size:12px;"
           [style.background]="isOfferExpiringSoon(promotionOffer.expiresAt) ? '#f8d7da' : '#fff3cd'"
           [style.color]="isOfferExpiringSoon(promotionOffer.expiresAt) ? '#721c24' : '#856404'"
           [style.border]="isOfferExpiringSoon(promotionOffer.expiresAt) ? '1px solid #f5c6cb' : '1px solid #ffc107'">
        <i class="pi pi-clock"></i>
        <b> Offer expires: {{ promotionOffer.expiresAt | date:'EEE M/d/yy h:mm a' }} ET</b>
        @if (isOfferExpiringSoon(promotionOffer.expiresAt)) {
          — <b>expiring soon</b>
        }
      </div>
      }

      <!-- OK -->
      @if (promotionPreview.decision === 'OK') {

      <!-- ── Direction selector (only for dual-direction offers) ─── -->
      @if (promotionOffer && promotionOffer.directions && promotionOffer.directions.length > 1) {
      <div style="font-size:12px; color:#555; font-weight:600; text-transform:uppercase;
                    letter-spacing:.5px; margin-bottom:6px;">Which Night(s)?</div>
      <div style="margin-bottom:14px; padding:10px; border:1px solid #ffeaa7; background:#fff9e6; border-radius:4px;">
        <div style="font-size:12px; color:#856404; margin-bottom:6px;">
          The guest was offered both nights. Pick which one(s) to extend below — preview will refresh.
        </div>
        <!-- PREV checkbox -->
        @if (isPrevSelectable()) {
        <label style="display:flex; align-items:center; gap:8px; padding:4px 0;"
               [style.cursor]="promotionPreview?.directionErrors?.['PREV'] ? 'not-allowed' : 'pointer'">
          <input type="checkbox" [checked]="selectedDirections.includes('PREV')"
                 (change)="toggleDirection('PREV', $event)"
                 [disabled]="isPrevApplied() || !!promotionPreview?.directionErrors?.['PREV']" />
          <span>
            <b>Day Before Arrival</b>
            <span style="color:#888; margin-left:4px;">({{ promotionOffer.prevDate | date:'EEE M/d/yyyy' }})</span>
            @if (isPrevApplied()) {
              <span style="color:#155724; font-size:11px; margin-left:8px;">✓ already applied {{ promotionOffer.prevState?.appliedDate | date:'M/d/yy h:mm a' }}</span>
            }
            @if (promotionPreview?.directionErrors?.['PREV']) {
              <span style="color:#721c24; font-size:11px; margin-left:8px;">⚠ unavailable</span>
            }
          </span>
        </label>
        }
        <!-- NEXT checkbox -->
        @if (isNextSelectable()) {
        <label style="display:flex; align-items:center; gap:8px; padding:4px 0;"
               [style.cursor]="promotionPreview?.directionErrors?.['NEXT'] ? 'not-allowed' : 'pointer'">
          <input type="checkbox" [checked]="selectedDirections.includes('NEXT')"
                 (change)="toggleDirection('NEXT', $event)"
                 [disabled]="isNextApplied() || !!promotionPreview?.directionErrors?.['NEXT']" />
          <span>
            <b>Day After Departure</b>
            <span style="color:#888; margin-left:4px;">({{ promotionOffer.nextDate | date:'EEE M/d/yyyy' }})</span>
            @if (isNextApplied()) {
              <span style="color:#155724; font-size:11px; margin-left:8px;">✓ already applied {{ promotionOffer.nextState?.appliedDate | date:'M/d/yy h:mm a' }}</span>
            }
            @if (promotionPreview?.directionErrors?.['NEXT']) {
              <span style="color:#721c24; font-size:11px; margin-left:8px;">⚠ unavailable</span>
            }
          </span>
        </label>
        }

        <!-- Conflict warning: shown when one or more directions are blocked -->
        @if (promotionPreview?.directionErrors && (promotionPreview.directionErrors['PREV'] || promotionPreview.directionErrors['NEXT'])) {
        <div style="margin-top:8px; padding:8px 10px; background:#f8d7da; border:1px solid #f5c6cb;
                    border-radius:4px; font-size:12px; color:#721c24;">
          <b><i class="pi pi-exclamation-triangle"></i> Conflict detected — one night is no longer available:</b>
          @if (promotionPreview.directionErrors['PREV']) {
          <div style="margin-top:4px;">
            <b>Day Before Arrival:</b> {{ promotionPreview.directionErrors['PREV'] }}
          </div>
          }
          @if (promotionPreview.directionErrors['NEXT']) {
          <div style="margin-top:4px;">
            <b>Day After Departure:</b> {{ promotionPreview.directionErrors['NEXT'] }}
          </div>
          }
          @if (selectedDirections.length > 0) {
          <div style="margin-top:6px; color:#155724; font-weight:600;">
            <i class="pi pi-check-circle"></i>
            You can still apply the available night{{ selectedDirections.length > 1 ? 's' : '' }} —
            click Apply below to proceed.
          </div>
          }
        </div>
        }

        @if (selectedDirections.length === 0) {
          <div style="color:#721c24; font-size:11px; margin-top:6px;">Select at least one night to continue.</div>
        }
      </div>
      }

      <!-- ── Date change ─────────────────────────────────────────── -->
      <div style="font-size:12px; color:#555; font-weight:600; text-transform:uppercase;
                    letter-spacing:.5px; margin-bottom:4px;">Reservation Change</div>
      <table style="width:100%; font-size:13px; line-height:1.8; margin-bottom:14px;">
        <tr>
          <td style="width:170px; color:#777;">Check-in</td>
          <td>{{ promotionPreview.currentCheckIn | date:'EEE M/d/yyyy' }}
            @if (promotionPreview.newCheckIn !== promotionPreview.currentCheckIn) {
            → <b>{{ promotionPreview.newCheckIn | date:'EEE M/d/yyyy' }}</b>
            }
          </td>
        </tr>
        <tr>
          <td style="color:#777;">Check-out</td>
          <td>{{ promotionPreview.currentCheckOut | date:'EEE M/d/yyyy' }}
            @if (promotionPreview.newCheckOut !== promotionPreview.currentCheckOut) {
            → <b>{{ promotionPreview.newCheckOut | date:'EEE M/d/yyyy' }}</b>
            }
          </td>
        </tr>
        <tr>
          <td style="color:#777;">Nights</td>
          <td>{{ promotionPreview.currentNights }} → <b>{{ promotionPreview.newNights }}</b></td>
        </tr>
      </table>

      <!-- ── Guest-facing invoice for the +1 night ──────────────── -->
      @if (promotionPreview.guestNightlyRate != null) {
      <div style="font-size:12px; color:#555; font-weight:600; text-transform:uppercase;
                      letter-spacing:.5px; margin-bottom:6px;">
        Cost for the Extra Night{{ selectedDirections.length > 1 ? 's' : '' }}
      </div>

      <table style="width:100%; font-size:13px; border-collapse:collapse; line-height:1.8;">

        <!-- 1. List nightly rate -->
        <tr style="border-bottom:1px solid #f0f0f0;">
          <td style="padding:4px 0; color:#555;">Nightly Rate</td>
          <td style="text-align:right; padding:4px 0; color:#333;">
            {{ promotionPreview.guestNightlyRate | currency:'USD' }}
          </td>
        </tr>

        <!-- 2. Coupon discount (only when reservation has one) -->
        @if (promotionPreview.couponDiscountPerNight != null) {
        <tr style="border-bottom:1px solid #f0f0f0;">
          <td style="padding:4px 0; color:#c0392b;">
            Coupon Discount
            @if (promotionPreview.couponCode) {
            <span style="font-size:11px; font-weight:600; margin-left:3px;">
              ({{ promotionPreview.couponCode }})
            </span>
            }
          </td>
          <td style="text-align:right; padding:4px 0; color:#c0392b;">
            −{{ promotionPreview.couponDiscountPerNight | currency:'USD' }}
          </td>
        </tr>

        <!-- 3. "Your nightly rate" sub-total — makes it clear what rate the
                       extension discount is being applied to -->
        <tr style="background:#eaf4fb; border-bottom:1px solid #b8d9ef;">
          <td style="padding:5px 8px; font-weight:600; color:#1a5276;">
            Your Nightly Rate
            <span style="font-weight:400; font-size:11px; color:#5d8aa8; margin-left:4px;">
              (after coupon)
            </span>
          </td>
          <td style="text-align:right; padding:5px 8px; font-weight:600; color:#1a5276;">
            {{ promotionPreview.guestNightlyAfterCoupon | currency:'USD' }}
          </td>
        </tr>
        }

        <!-- 4. Extension discount — applied to after-coupon rate -->
        <tr style="border-bottom:1px dashed #ddd;">
          <td style="padding:4px 0; color:#c0392b;">
            Extension Discount
            @if (promotionPreview.extensionDiscountPct != null) {
            <span style="font-size:11px; font-weight:600; margin-left:3px;">
              ({{ promotionPreview.extensionDiscountPct | number:'1.0-1' }}% off)
            </span>
            }
          </td>
          <td style="text-align:right; padding:4px 0; color:#c0392b;">
            −{{ promotionPreview.extensionDiscountAmt | currency:'USD' }}
          </td>
        </tr>

        <!-- 5. Per-night fees (Resort Fee, Destination Fee, etc.) -->
        @if (promotionPreview.extraNightFees && promotionPreview.extraNightFees.length > 0) {
        @for (fee of promotionPreview.extraNightFees; track fee.feeName) {
        <tr style="border-bottom:1px solid #f0f0f0;">
          <td style="padding:4px 0; color:#555;">{{ fee.feeName }}</td>
          <td style="text-align:right; padding:4px 0; color:#333;">
            {{ fee.amount | currency:'USD' }}
          </td>
        </tr>
        }
        }

        <!-- 6. Subtotal -->
        <tr style="border-top:1px solid #ccc;">
          <td style="padding:5px 0; color:#444;">Subtotal</td>
          <td style="text-align:right; padding:5px 0; color:#333;">
            {{ promotionPreview.extraNightSubtotal | currency:'USD' }}
          </td>
        </tr>

        <!-- 7. Tax -->
        @if (promotionPreview.taxAmt != null) {
        <tr style="border-bottom:1px solid #ccc;">
          <td style="padding:4px 0; color:#444;">Tax</td>
          <td style="text-align:right; padding:4px 0; color:#333;">
            {{ promotionPreview.taxAmt | currency:'USD' }}
          </td>
        </tr>
        }

        <!-- 8. Grand total -->
        <tr style="background:#e8f5e9; border-top:2px solid #27ae60;">
          <td style="padding:8px 6px; font-weight:700; font-size:14px; color:#1a5c32;">
            Total for Extra Night{{ selectedDirections.length > 1 ? 's' : '' }}
          </td>
          <td style="text-align:right; padding:8px 6px; font-weight:700; font-size:16px; color:#27ae60;">
            {{ promotionPreview.extraNightGuestTotal | currency:'USD' }}
          </td>
        </tr>

      </table>
      }

      <!-- ── Internal note ──────────────────────────────────────── -->
      <div style="margin-top:12px; padding:8px 10px; background:#faf2dd;
                    border:1px solid #e0d4b6; border-radius:4px; font-size:12px; color:#856404; line-height:1.5;">
        <i class="pi pi-info-circle"></i>
        <b> After Apply:</b>
        Nightly rate stays at
        <b style="color:#27ae60; font-size:13px;">{{ promotionPreview.recommendedListPriceAdjustmentAmount |
          currency:'USD' }}</b>
        per night (unchanged).
        @if (promotionPreview.extensionDiscountAmt != null) {
        <span style="color:#856404;">
          @if (selectedDirections.length > 1) {
            Two promotion discount lines (one per added night) totalling
            <b>−{{ promotionPreview.extensionDiscountAmt | currency:'USD' }}</b>
            are added as separate adjustment lines.
          } @else {
            A promotion discount of <b>−{{ promotionPreview.extensionDiscountAmt | currency:'USD' }}</b>
            is added as a separate adjustment line.
          }
        </span>
        }
      </div>

      <!-- ── What Apply will do ──────────────────────────────────── -->
      <div style="margin-top:10px; padding:8px 10px; background:#d1ecf1;
                    color:#0c5460; border-radius:4px; font-size:12px; line-height:1.5;">
        <i class="pi pi-info-circle"></i> <b>Clicking Apply will automatically:</b>
        <ul style="margin:4px 0 0 18px; padding:0;">
          <li>Re-check the adjacent night{{ selectedDirections.length > 1 ? 's are' : ' is' }} still free (no double-booking)</li>
          <!-- Date-edge summary: differs depending on which directions are being applied -->
          @if (selectedDirections.includes('PREV') && selectedDirections.includes('NEXT')) {
            <li>Extend the reservation: new check-in <b>{{ promotionPreview.newCheckIn | date:'M/d/yyyy' }}</b>,
              new check-out <b>{{ promotionPreview.newCheckOut | date:'M/d/yyyy' }}</b>
              ({{ promotionPreview.currentNights }} → {{ promotionPreview.newNights }} nights)</li>
          } @else if (selectedDirections.includes('PREV')) {
            <li>Extend the reservation backward to new check-in
              <b>{{ promotionPreview.newCheckIn | date:'M/d/yyyy' }}</b>
              ({{ promotionPreview.currentNights }} → {{ promotionPreview.newNights }} nights)</li>
          } @else {
            <li>Extend the reservation to new check-out
              <b>{{ promotionPreview.newCheckOut | date:'M/d/yyyy' }}</b>
              ({{ promotionPreview.currentNights }} → {{ promotionPreview.newNights }} nights)</li>
          }
          @if (promotionPreview.couponDiscountPerNight != null) {
          <li>Scale the existing coupon to cover {{ promotionPreview.newNights }} nights</li>
          }
          @if (promotionPreview.extensionDiscountAmt != null) {
            @if (selectedDirections.length > 1) {
              <li>Add <b>two Promotion Extension Discount lines</b> totalling
                −{{ promotionPreview.extensionDiscountAmt | currency:'USD' }}
                ({{ promotionPreview.extensionDiscountPct | number:'1.0-0' }}% off each added night)</li>
            } @else {
              <li>Add a <b>Promotion Extension Discount</b> line of −{{ promotionPreview.extensionDiscountAmt |
                currency:'USD' }}
                ({{ promotionPreview.extensionDiscountPct | number:'1.0-0' }}% off the extra night)</li>
            }
          }
          <li>Scale per-night fees (Resort Fee, etc.) to the new night count</li>
          <li>Regenerate the invoice and notify downstream systems</li>
        </ul>
        <div style="margin-top:4px; font-style:italic;">
          If anything goes wrong, the offer will NOT be marked
          {{ willBeFullyAppliedAfter() ? 'APPLIED' : 'PARTIALLY APPLIED' }} — you can retry or extend manually.
        </div>
      </div>

      <!-- ── Payment reminder ──────────────────────────────────── -->
      @if (promotionOffer?.referralSourceId === 1 || promotionOffer?.referralSourceId === 7 ||
      promotionOffer?.referralSourceId === 11) {
      <!-- Website / VRBO / Google: card will be charged automatically on Apply -->
      <div style="margin-top:8px; padding:8px 10px; background:#e8f5e9;
                      color:#1a5c32; border:1px solid #a5d6a7; border-radius:4px; font-size:12px; line-height:1.5;">
        <i class="pi pi-credit-card"></i>
        <b> Guest's saved card will be charged automatically on Apply.</b>
        Amount: <b>{{ promotionPreview.extraNightGuestTotal | currency:'USD' }}</b>.
        If the charge is declined you will be notified and can collect via <b>Run Payment</b>.
      </div>
      } @else {
      <!-- Other sources: no card on file -->
      <div style="margin-top:8px; padding:8px 10px; background:#fff3cd;
                      color:#856404; border:1px solid #ffc107; border-radius:4px; font-size:12px; line-height:1.5;">
        <i class="pi pi-exclamation-triangle"></i>
        <b> No credit card charge is made automatically.</b>
        After applying, the outstanding balance will increase by
        <b>{{ promotionPreview.extraNightGuestTotal | currency:'USD' }}</b>.
        Remember to collect payment from the guest manually via <b>Run Payment</b>.
      </div>
      }

      }
      }

      <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-text"
          (click)="promotionPreviewVisible = false" [disabled]="promotionApplying"></button>
        @if (promotionPreview?.decision === 'OK') {
        <button pButton type="button" label="Apply" icon="pi pi-check" style="background:#27ae60; border-color:#27ae60;"
          (click)="confirmPromotionApply()" [disabled]="promotionApplying">
          @if (promotionApplying) { <i class="pi pi-spin pi-spinner ml-2"></i> }
        </button>
        }
      </ng-template>
    </p-dialog>
    <!-- ===== END Apply confirmation modal ===== -->
    @if (promotionOfferLoading && !promotionOffer) {
    <div class="mt-3 text-center p-3"><i class="pi pi-spin pi-spinner" style="font-size: 1rem;"></i> Loading promotion
      offer…</div>
    }
    <!-- ===== END PROMOTION OFFER CARD ===== -->

    <!-- ===== UPSELL LOG (inline) ===== -->
    <div class="mt-3 change-log">
      <div class="title border-bottom-1 mb-2 titleblue d-flex justify-content-between align-items-center">
        <h4 class="m-0 text-black fw-bold">Upsell Log</h4>
        <button pButton type="button" label="Refresh" icon="pi pi-refresh" class="p-button-sm p-button-secondary"
          (click)="loadUpsellLogs(order?.reservations[0]?.reservationId)"></button>
      </div>
      @if (upsellLogsLoading) {
      <div class="text-center p-3">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
      </div>
      }
      @if (!upsellLogsLoading && upsellLogs.length === 0) {
      <div class="p-2" style="color: #888;">
        No upsell log entries found.
      </div>
      }
      @for (log of upsellLogs; track log) {
      <div
        style="border: 1px solid #dee2e6; border-radius: 4px; margin-bottom: 8px; padding: 8px; background: #fafafa;">
        <table style="width: 100%; margin-bottom: 4px; font-size: 13px;">
          <tr>
            <td style="min-width: 80px; font-weight: bold; text-align: right; padding-right: 8px; white-space: nowrap;">
              Date:</td>
            <td style="padding-right: 16px;">{{ log.createDate | date:'M/d/yy h:mm:ss a' }}</td>
            <td style="min-width: 80px; font-weight: bold; text-align: right; padding-right: 8px; white-space: nowrap;">
              Severity:</td>
            <td>
              <b [ngStyle]="{
								'color': log.severity === 'ERROR'   ? '#c0392b' :
										 log.severity === 'REPORT' || log.severity === 'SUCCESS' ? '#27ae60' :
										 log.severity === 'DEBUG'  ? '#888' :
										 log.severity === 'WARN'   ? '#c9a800' : '#2980b9'
							}">{{ log.severity }}</b>
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; text-align: right; padding-right: 8px; white-space: nowrap;">Method:</td>
            <td colspan="3" style="font-size: 12px; color: #555;">{{ log.methodName }}</td>
          </tr>
        </table>
        <hr style="margin: 4px 0; border-color: #dee2e6;">
        <pre
          style="white-space: pre-wrap; word-break: break-word; font-size: 12px; margin: 0; font-family: inherit;">{{ log.message }}</pre>
      </div>
      }
    </div>
    <!-- ===== END UPSELL LOG ===== -->
  </mat-tab>
</mat-tab-group>

<p-dialog class="payment-popup" header="PAYMENT SRC & CONF EDIT" [(visible)]="visible" [modal]="true"
  [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false"
  [ngClass]="{'has-error': form4.invalid && (form4.dirty || form4.touched)}">
  <div [formGroup]="form4" class="">
    <div class="common-popup mt-1">
      <h3>Invoice Order Details</h3>
      <div class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" [options]="applyToList" formControlName="reservationId" optionLabel="name"
              optionValue="value" placeholder="">
              <ng-template pTemplate="item" let-item>
                <span>{{item.label}}</span>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                <span>{{item.name}}</span>
              </ng-template>
            </p-dropdown>
            @for (validation of validationMessages3.reservationId; track validation) {
            <span>
              @if (form4.get('reservationId').hasError(validation.type) && (form4.get('reservationId').dirty ||
              form4.get('reservationId').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-calendar formControlName="effectiveDate" id="effectiveDate">
            </p-calendar>
            <label for="Date">Initiated</label>
            @for (validation of validationMessages3.effectiveDate; track validation) {
            <span>
              @if (form4.get('effectiveDate').hasError(validation.type) && (form4.get('effectiveDate').dirty ||
              form4.get('effectiveDate').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" [options]="invoiceDetailTypes" formControlName="type" optionLabel="name"
              optionValue="value" placeholder=""></p-dropdown>
            <label for="Date">Trx</label>
            @for (validation of validationMessages3.type; track validation) {
            <span>
              @if (form4.get('type').hasError(validation.type) && (form4.get('type').dirty ||
              form4.get('type').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="description" id="description" type="text" pInputText>
            <label for="Date">Guest Notes</label>
            @for (validation of validationMessages3.description; track validation) {
            <span>
              @if (form4.get('description').hasError(validation.type) && (form4.get('description').dirty ||
              form4.get('description').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="privateNotes" id="privateNotes" type="text" pInputText>
            <label for="Date">Private Notes </label>
            @for (validation of validationMessages3.privateNotes; track validation) {
            <span>
              @if (form4.get('privateNotes').hasError(validation.type) && (form4.get('privateNotes').dirty ||
              form4.get('privateNotes').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <p-inputNumber formControlName="amount" [minFractionDigits]="2" inputId="currency-us" mode="currency"
              currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="amount">Amount</label>
            @for (validation of validationMessages3.amount; track validation) {
            <span>
              @if (form4.get('amount').hasError(validation.type) && (form4.get('amount').dirty ||
              form4.get('amount').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
      </div>
    </div>
    <div formGroupName="paymentConfirm" class="common-popup mt-1">
      <h3>PaymentConfirm</h3>
      <div class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <p-calendar formControlName="paymentProcessDate" inputId="pageStartDate">
            </p-calendar>
            <label for="Date">Received</label>
            @for (validation of validationMessages3.paymentProcessDate; track validation) {
            <span>
              @if (form4.get('paymentConfirm.paymentProcessDate').hasError(validation.type) &&
              (form4.get('paymentConfirm.paymentProcessDate').dirty ||
              form4.get('paymentConfirm.paymentProcessDate').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <p-inputNumber formControlName="paymentProcessAmount" [minFractionDigits]="2" inputId="currency-us"
              mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="paymentProcessAmount">Processed Amount</label>
            @for (validation of validationMessages3.paymentProcessAmount; track validation) {
            <span>
              @if (form4.get('paymentConfirm.paymentProcessAmount').hasError(validation.type) &&
              (form4.get('paymentConfirm.paymentProcessAmount').dirty ||
              form4.get('paymentConfirm.paymentProcessAmount').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="paymentTypes" formControlName="paymentType" optionLabel="name" optionValue="value"
              [filter]="false" filterBy="name" [showClear]="false" placeholder="Payment Type">
            </p-dropdown>
            <label for="paymentType">Type</label>
            @for (validation of validationMessages3.paymentType; track validation) {
            <span>
              @if (form4.get('paymentConfirm.paymentType').hasError(validation.type) &&
              (form4.get('paymentConfirm.paymentType').dirty || form4.get('paymentConfirm.paymentType').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentGatewayProvider" id="paymentGatewayProvider" type="text" pInputText>
            <label for="paymentGatewayProvider">Payment Gateway Provider</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber" type="text"
              pInputText>
            <label for="paymentTransactionConfirmNumber">Conf#</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier" type="text"
              pInputText>
            <label for="paymentSourceAccountIdentifier">Chk#</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" formControlName="paymentProceedsDepositedToAccountIdentifier"
              [options]="paymentDepositTypes" optionLabel="name" optionValue="value" placeholder=""></p-dropdown>
            <label for="paymentProceedsDepositedToAccountIdentifier">Deposit A/C#</label>
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingName" id="billingName" type="text" pInputText>
            <label for="billingName">Billing Name</label>
            @for (validation of validationMessages3.billingName; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingName').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingName').dirty || form4.get('paymentConfirm.billingName').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingStreetAddress" id="billingStreetAddress" type="text" pInputText>
            <label for="billingStreetAddress">Billing Street Address</label>
            @for (validation of validationMessages3.billingStreetAddress; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingStreetAddress').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingStreetAddress').dirty ||
              form4.get('paymentConfirm.billingStreetAddress').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingCity" id="billingCity" type="text" pInputText>
            <label for="billingCity">Billing City</label>
            @for (validation of validationMessages3.billingCity; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingCity').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingCity').dirty || form4.get('paymentConfirm.billingCity').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingState" id="billingState" type="text" pInputText>
            <label for="billingState">Billing State</label>
            @for (validation of validationMessages3.billingState; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingState').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingState').dirty || form4.get('paymentConfirm.billingState').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingPostalCode" id="billingPostalCode" type="text" pInputText>
            <label for="billingPostalCode">Billing Postal Code</label>
            @for (validation of validationMessages3.billingPostalCode; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingPostalCode').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingPostalCode').dirty ||
              form4.get('paymentConfirm.billingPostalCode').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="countries" formControlName="billingCountry" optionLabel="name" optionValue="abbr"
              [filter]="true" filterBy="name" [showClear]="false" placeholder="Billing Country"></p-dropdown>
            <label for="billingCountry">Billing Country</label>
            @for (validation of validationMessages3.billingCountry; track validation) {
            <span>
              @if (form4.get('paymentConfirm.billingCountry').hasError(validation.type) &&
              (form4.get('paymentConfirm.billingCountry').dirty || form4.get('paymentConfirm.billingCountry').touched))
              {
              <small class="p-invalid">{{validation.message}}
              </small>
              }
            </span>
            }
          </div>
        </div>

      </div>
    </div>


    <div formGroupName="paymentConfirm" class="common-popup mt-1">
      <h3>PaymentSource</h3>
      <div formGroupName="paymentSource" class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBankName" id="achBankName" type="text" pInputText>
            <label for="achBankName">Ach Bank Name</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achRoutingNumber" id="achRoutingNumber" type="text" pInputText>
            <label for="achRoutingNumber">Ach Routing Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBankAccountNumber" id="achBankAccountNumber" type="text" pInputText>
            <label for="achBankAccountNumber">Ach Bank Account Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBranchSortCode" id="achBranchSortCode" type="text" pInputText>
            <label for="achBranchSortCode">Ach Branch Sort Code</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achAccountType" id="achAccountType" type="text" pInputText>
            <label for="achAccountType">Ach Account Type</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achCheckNumber" id="achCheckNumber" type="text" pInputText>
            <label for="achCheckNumber">Ach Check Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achMicrData" id="achMicrData" type="text" pInputText>
            <label for="achMicrData">Ach Micr Data</label>
          </div>
        </div>
        <br>
        <!-- <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="paymentTypes" formControlName="paymentType" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
              placeholder="Payment type">
            </p-dropdown>
            <label for="cn">Credit Card Type</label>
          </div>
        </div> -->
        <div class="col-6">
          <div class="p-float-label">
            <input name="creditCardNumber" formControlName="creditCardNumber" name="creditCardNumber" minlength="15"
              maxlength="19" type="text" autocomplete="cc-number" pInputText>
            <label for="creditCardNumber">Credit Card Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="cardExpiryMonths" formControlName="creditCardExpirationMonth" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
              placeholder="Credit Card Expiration Month"> </p-dropdown>
            <label for="creditCardExpirationMonth">Credit Card Expiration Month</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="cardExpiryYears" formControlName="creditCardExpirationYear" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
              placeholder="Credit Card Expiration Year">
            </p-dropdown>
            <label for="creditCardExpirationYear">Credit Card Expiration Year</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input name="creditCardSecurityCode" formControlName="creditCardSecurityCode" type="number" pInputText>
            <label for="creditCardSecurityCode">Credit Card Security Code</label>
          </div>
        </div>
        <!-- <div class="col-12">
        <div class="p-float-label">
          <textarea name="" id=""></textarea>
          <label for="cs">Log</label>
        </div>
      </div> -->

      </div>
    </div>

    <div class="col-sm-12 p-0 leftbtn">
      <div class="d-flex align-items-center justify-content-between">
        <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 py-2">
          <button type="button" class="btn-delete btn btn-light p-button-outlined p-button-danger"
            (click)="deleteOrderInvoiceDetailConfirmation()">Delete</button>
        </div>
        <div class="text-center">
          <a style="font-size: 14px; color: #3F51B5;" (click)="sendEmailPaymentRecieveToGuest()">Email Payment
            Received</a>
        </div>
        <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 py-2">
          <button type="button" class="btn-cancel btn btn-light p-button-text mr-2"
            (click)="closeDialog()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="formLoading" (click)="updateInvoiceOrder()">Update</button>
        </div>
      </div>
    </div>
  </div>


</p-dialog>

<!-- <p-dialog *ngIf="errorList.length > 0 && showValidationErrors" header="Reservation Update Info"
[(visible)]="showValidationErrors" [style]="{width: 'auto', height: 'auto'}">
<div class="error-mess" [innerHTML]="errorMessages"></div>
</p-dialog> -->

<p-dialog header="Payment Flow Guide" [(visible)]="showPaymentHelp" [modal]="true" [closable]="true"
  [style]="{ width: '520px' }" [draggable]="false" [resizable]="false">
  <ul style="padding-left: 1.2rem; line-height: 1.7;">
    <li>
      <strong>Make Payment</strong><br>
      Charges the guest's card immediately (one-step). Use for collecting additional fees, balance due, or any new
      charge.
      The button disables while processing — wait for confirmation before retrying.
    </li>
    <li style="margin-top: 0.75rem;">
      <strong>Capture &amp; Sync</strong> <em>(appears only on authorized-but-not-captured rows)</em><br>
      An authorization hold was placed on the guest's card but not collected yet. Click this to capture the funds.
      This updates both Authorize.net and KBMAdmin in one click. Use this instead of capturing manually in the
      Authorize.net portal.
    </li>
    <li style="margin-top: 0.75rem;">
      <strong>Reconcile Captured</strong> <em>(sync only — does NOT charge)</em><br>
      Use only if a capture was already done directly in the Authorize.net portal. This reads the current status
      from Authorize.net and updates KBMAdmin to match. It does not initiate any new charge.
    </li>
    <li style="margin-top: 0.75rem;">
      <strong>Authorization Holds</strong><br>
      Auths expire in approximately 7 days. If a "Capture &amp; Sync" row is older than 7 days, check Authorize.net
      first — the hold may have already expired. An automated hourly check alerts accounting when auth holds
      are found.
    </li>
  </ul>
</p-dialog>